import { Box, Button, Typography } from '@mui/material'
import { useContext, useState } from 'react'
import AppContext from '../../../context/appContext'
import { useUpdatePerimeter } from '../../../hooks/data/useUpdatePerimeter'
import DrawingPencil from '../../Icons/DrawingPencil'
import PerimeterConfirm from '../modals/PerimeterConfirm'
import { perimetersToMultiPolygon } from '../../../utils/FarmLayers/perimeter'
import { useProcessLoading } from '../../../utils/Loading/useProcessLoading'

const getPerimeterAreaTotal = perimeter => {
  let perimeterAreaTotal = 0
  perimeter?.forEach(feature => {
    perimeterAreaTotal += parseFloat(feature.properties.area)
  })
  return `${perimeterAreaTotal.toFixed(2)} ha`
}

const Manual = ({
  handleDrawingType,
  etapa,
  handleEtapa,
  perimeter,
  handlePerimeter,
  handlePerimeterSaved,
  center,
}) => {
  const { currentFarm, setPartialChanges } = useContext(AppContext)

  const [modalConfirmationOpen, setModalConfirmationOpen] = useState(false)

  const { processLoading } = useProcessLoading()
  const { mutateAsync: updatePerimeter } = useUpdatePerimeter({ farmId: currentFarm?.id })

  const handleOpen = () => {
    setModalConfirmationOpen(true)
  }
  const handleClose = () => {
    setModalConfirmationOpen(false)
  }

  const setManualSelection = () => {
    handleEtapa('drawingStarted')
    handleDrawingType('perimeter')
  }

  const cancelManualSelection = () => {
    handleEtapa('inicial')
  }

  const handleSavePerimeter = async () => {
    await processLoading({
      loadingMessage: 'Guardando perímetro...',
      doAction: async () => {
        await updatePerimeter({
          farm: currentFarm,
          geometry: perimetersToMultiPolygon(perimeter).geometry,
          center,
        })

        handleEtapa('showingFoldersManual')
        await handlePerimeterSaved()
        setPartialChanges(false)
      },
    })
    handleClose()
  }

  const clearMap = () => {
    handlePerimeter(null)
    setPartialChanges(false)
  }

  return (
    <Box>
      <Typography
        sx={{
          fontSize: 14,
          margin: 2,
          marginTop: 4,
        }}
      >
        Dibuje el perímetro del establecimiento marcando los puntos que lo definen.
      </Typography>
      {etapa === 'inicialManual' ? (
        <Box
          sx={{
            flexDirection: 'column',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 2,
          }}
        >
          <DrawingPencil />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              mt: 1,
            }}
          >
            <Button
              sx={{
                backgroundColor: '#1976d2',
                color: 'white',
                borderRadius: 4,
                margin: 2,
                px: 2,
                fontWeight: 600,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#1976d2',
                  color: 'white',
                  opacity: 0.8,
                },
              }}
              onClick={setManualSelection}
            >
              Dibujar perímetro
            </Button>
            <Button
              sx={{
                color: '#1976d2',
                backgroundColor: 'white',
                margin: 2,
                px: 2,
                fontWeight: 600,
                textTransform: 'none',
              }}
              onClick={cancelManualSelection}
            >
              Cancelar
            </Button>
          </Box>
        </Box>
      ) : null}
      {etapa === 'drawingStarted' || etapa === 'drawingFinished' ? (
        <Box
          sx={{
            flexDirection: 'column',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 2,
          }}
        >
          {perimeter ? (
            <>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 600,
                  margin: 2,
                }}
              >
                {perimeter?.length > 0 ? getPerimeterAreaTotal(perimeter) : null}
              </Typography>
              {etapa !== 'drawingFinished' ? (
                <div>
                  <Button
                    sx={{
                      backgroundColor: '#1976d2',
                      color: 'white',
                      borderRadius: 4,
                      margin: 2,
                      px: 2,
                      fontWeight: 600,
                      textTransform: 'none',
                      '&:hover': {
                        backgroundColor: '#1976d2',
                        color: 'white',
                        opacity: 0.8,
                      },
                    }}
                    onClick={handleOpen}
                  >
                    Confirmar perímetro
                  </Button>
                  <PerimeterConfirm
                    buttonValue="showingFoldersManual"
                    handleClose={handleClose}
                    handleConfirm={handleSavePerimeter}
                    open={modalConfirmationOpen}
                  />

                  <Button
                    sx={{
                      backgroundColor: 'white',
                      color: '#1976d2',
                      borderRadius: 4,
                      margin: 2,
                      px: 2,
                      fontWeight: 600,
                      textTransform: 'none',
                      border: '1px solid #1976d2',
                      '&:hover': {
                        backgroundColor: 'white',
                        color: '#1976d2',
                        opacity: 0.8,
                      },
                    }}
                    onClick={clearMap}
                  >
                    Limpiar mapa
                  </Button>
                </div>
              ) : null}
            </>
          ) : null}
        </Box>
      ) : null}
    </Box>
  )
}

export default Manual
